import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import DropdownActivator from 'scaleflow/utils/dropdown-activate';
import type StoreService from 'scaleflow/services/store';
import type IdeaModel from 'scaleflow/models/idea';
import GroupModel from 'scaleflow/models/group';

export interface IdeasTableCellGroupSignature {
  // The arguments accepted by the component
  Args: {
    idea?: IdeaModel;
    disabled?: boolean;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}

export default class IdeasTableCellGroupComponent extends DropdownActivator<IdeasTableCellGroupSignature> {
  @service declare store: StoreService;
  @tracked groupFormIsVisible = false;
  selectedIdea: null | IdeaModel = null;

  get idea() {
    return this.args.idea;
  }

  @action
  handleGroupChange(idea: IdeaModel, group: { label: string; value: string }) {
    if (group) {
      const groupRecord = this.store.peekRecord<GroupModel>(
        'group',
        group.value,
      );
      idea.set('group', groupRecord);
    } else {
      idea.set('group', null);
    }
    void idea.save();
  }

  @action
  handleClearSelection(idea: IdeaModel) {
    idea.set('group', null);
    void idea.save();
  }

  @action
  toggleGroupForm(idea?: IdeaModel, val?: boolean) {
    if (idea) this.selectedIdea = idea;
    else this.selectedIdea = null;
    if (val !== undefined) this.groupFormIsVisible = val;
    else this.groupFormIsVisible = !this.groupFormIsVisible;
  }

  @action
  async onGroupAdded(group: GroupModel) {
    if (this.selectedIdea) {
      this.selectedIdea.set('group', group);
      await this.selectedIdea.save();
    }
  }

  get groupsList() {
    const groups = this.store
      .peekAll<GroupModel>('group')
      .map((item: GroupModel) => ({
        value: item.id,
        label: item.title,
      }));
    return groups;
  }

  willDestroy() {
    this.groupFormIsVisible = false;
    this.selectedIdea = null;
    super.willDestroy();
  }
}
